import { Field, Form, Formik } from "formik";
import React from "react";
import { Base } from "../base";
import { AutocompleteChangeReason, Grid } from "@mui/material";
import { Inputs } from "../formInputs";
import { useSelector } from "../../store";
import KeyValue from "../../types/keyValue";
import SearchParams, { defaultParams } from "../../types/searchParams";
import { debounce } from "lodash";

interface Props {
  apiSiteTypeSearch: (search: SearchParams) => void;
  handleFiltering: (filterName: string, e?: KeyValue) => void;
  apiSiteSearch: (search: SearchParams) => Promise<void>;
  setFilter: (params: SearchParams) => void;
  phone: boolean;
}

const SitesFilterForm: React.FC<Props> = (props) => {
  const {
    apiSiteTypeSearch,
    handleFiltering,
    apiSiteSearch,
    setFilter,
    phone,
  } = props;

  const { siteTypeSearchResults } = useSelector((store) => store.siteType);
  const { siteFilter } = useSelector((store) => store.site);

  const updateSearch = debounce((query: string) => {
    apiSiteSearch({
      ...siteFilter,
      query: query,
      pageNumber: 1,
      pageSize: 10,
    });
    setFilter({
      ...siteFilter,
      query: query,
      pageNumber: phone ? 2 : 1,
      pageSize: 10,
    });
  }, 500);

  const updateSiteTypeSearch = debounce((query: string) => {
    apiSiteTypeSearch({ ...defaultParams, query: query });
  }, 500);

  return (
    <Formik initialValues={{ siteType: undefined }} onSubmit={() => {}}>
      {({ resetForm }) => (
        <Form noValidate>
          <Base.BorderBox>
            <Grid size={{ xs: 12 }} px={1}>
              <Field
                name="siteType"
                label="Site Type"
                component={Inputs.Dropdown}
                options={siteTypeSearchResults?.results || []}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateSiteTypeSearch(e.currentTarget.value);
                }}
                onFocus={() => {
                  apiSiteTypeSearch(defaultParams);
                }}
                onSelected={(
                  event: React.SyntheticEvent,
                  value: any | Array<any>,
                  reason: AutocompleteChangeReason
                ) => {
                  handleFiltering("siteType", value);
                  if (reason === "clear") {
                    apiSiteTypeSearch(defaultParams);
                  }
                }}
              />
            </Grid>
            <Grid size={{ md: 10, xs: 12 }} pb={2} px={1}>
              <Base.Search
                label="Search"
                handleChange={updateSearch}
                value={siteFilter.query}
              />
            </Grid>
            <Grid size={{ md: 2, xs: 12 }} pb={2} px={{ md: "15px", xs: 0 }}>
              <Base.Button
                text="Reset"
                onClick={() => {
                  resetForm();
                  apiSiteSearch(defaultParams).then(() => {
                    setFilter({
                      ...defaultParams,
                      pageNumber: phone ? 2 : 1,
                    });
                  });
                }}
                fullWidth
              />
            </Grid>
          </Base.BorderBox>
        </Form>
      )}
    </Formik>
  );
};

export default SitesFilterForm;
